import rem from 'polished/lib/helpers/rem';
import { makeStyles } from 'tss-react/mui';

interface Props {
  isHovered: boolean;
  isQuickAnswer: boolean;
}

export default makeStyles<Props>()(
  ({ color }, { isHovered, isQuickAnswer }) => ({
    container: {
      aspectRatio: '1 / 1',
      position: 'relative',
      overflow: 'hidden',
      borderRadius: rem(16),
      background: color.background.muted,
      boxShadow: '0px 8px 12px -4px #18181B14',
    },
    picture: {
      objectFit: 'cover',
      transition: 'transform 0.5s ease',
      transform: isHovered ? 'scale(1.1)' : 'scale(1)',
    },
    pictureHeader: {
      display: 'flex',
      position: 'absolute',
      top: 0,
      width: '100%',
      justifyContent: isQuickAnswer ? 'space-between' : 'flex-end',
      padding: `${rem(12)} ${rem(16)}`,
    },
    pictureFooter: {
      display: 'flex',
      gap: rem(5),
      alignItems: 'end',
      position: 'absolute',
      padding: `${rem(12)} ${rem(16)}`,
      width: '100%',
      background: `linear-gradient(180deg, #18181b00 0%, #18181bb3 100%)`,
      bottom: 0,
    },
    teacherFirstName: {
      color: color.foreground.emphasis,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  })
);
